// extracted by mini-css-extract-plugin
module.exports = {"contact_bio":"ThreeColContact_contact_bio__2UllA","contact_direction":"ThreeColContact_contact_direction__8Djey"};